import React from 'react';
import { useParams } from 'react-router-dom';
import { loadThoughtsMetadata } from '../components/unspokenThoughts/LoadMetadata';
import NotFound from './NotFound';

const StandaloneThoughtView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const artPieces = loadThoughtsMetadata();
  const artPiece = artPieces.find((art) => art.id === id);

  if (!artPiece) {
    return <NotFound />;
  }

  const Component = React.lazy(() =>
    import(`../components/unspokenThoughts/${id}/${id}`).catch(() => {
      return { default: () => <div>Not Found. Try Again!</div> };
    })
  );

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Component standalone={true} />
    </React.Suspense>
  );
};

export default StandaloneThoughtView;
